import React from "react";
import NotificationsTable from "./NotificationsTable";

function Notifications() {
  return (
    <>
      <div className="flex mx-auto self-center">
        <div className="flex flex-col flex-1">
          <h1 className="font-title text-2xl mb-2">Notifications</h1>
          <NotificationsTable />
        </div>
      </div>
    </>
  );
}

export default Notifications;
